__turbopack_context__.v({
  "answer": "krails-replace-systems-module__Ma1feq__answer",
  "body": "krails-replace-systems-module__Ma1feq__body",
  "brandLtr": "krails-replace-systems-module__Ma1feq__brandLtr",
  "card": "krails-replace-systems-module__Ma1feq__card",
  "inner": "krails-replace-systems-module__Ma1feq__inner",
  "pills": "krails-replace-systems-module__Ma1feq__pills",
  "question": "krails-replace-systems-module__Ma1feq__question",
  "section": "krails-replace-systems-module__Ma1feq__section",
});
